import React, { useState, useEffect, Fragment } from "react";
import Box from "@mui/material/Box";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import MpgItem from "../../../../CommonFormComp/MpgItem";
import MpgFileUpload from "../../../../fileHandling/MpgFileUpload";
import { uploadAndCreateCustomPDValidation } from "./uploadAndCreateCustomPDValidation";
import { managePDViewPath } from "../../../../routes/routePaths";
import MpgErrorDialog from "../../../../common/dialog/MpgErrorDialog";
import MpgLoadingDialog from "../../../../common/dialog/MpgLoadingDialog";
import { useGetLoggedInUserDetails } from "../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import { useCreateProgramDescriptorMutation, useUploadProgramDescriptorFileMutation } from "../../../../reactQueries/AppApi/rqHooksForProgrammeDescriptor";
import useTrackUserActivity from "../../../../userActivityTracking/useTrackUserActivity";
import MpgInput from "../../../../CommonFormComp/MpgInput";
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormHelperText from '@mui/material/FormHelperText';

const UploadAndCreateCustomPD = ({ open, setOpen, addedPDData, setAddedPDData }) => {
  const navigate = useNavigate();

  const { loggedInUser } = useGetLoggedInUserDetails();
  const { emailAddress } = loggedInUser;

  /**dialog actions */

  useEffect(() => {
    if (!!open) {
      setOpen(true)
    } else {
      setOpen(false)
    }
  }, [open])

  const handleClose = (event, reason) => {
    if (reason && reason == "backdropClick") {
      return '';
    } else {
      setOpen(false);
    }

    reset({ customPDTitle: "" })
  };

  /** !!!!!!!! form handling  !!!!!!!! */

  const { schema } = uploadAndCreateCustomPDValidation();

  const rhfFormInstanceForCustomPD = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      customPDFile: []
    }
  });

  const { watch, setValue, reset } = rhfFormInstanceForCustomPD;

  const inputPDTitle = watch("customPDTitle")

  /** !!!!!!!! API calls  !!!!!!!! */

  // api - create report resource mutation
  const {
    mutate: createProgramDescriptor,
    isError: isErrorOnCreate,
    isLoading: isLoadingOnCreate,
    isSuccess: isSuccessOnCreate,
    data: dataOnCreate,
    error: errorOnCreate,
    reset: resetOnCreate
  } = useCreateProgramDescriptorMutation();

  // console.log("dataOnCreate!!!", dataOnCreate)

  const {
    mutate: uploadPDFile,
    isError: isErrorOnPDFileUpload,
    isLoading: isLoadingOnPDFileUpload,
    isSuccess: isSuccessOnPDFileUpload,
    data: dataOnPDFileUpload,
    error: errorOnPDFileUpload,
    reset: resetOnPDFileUpload
  } = useUploadProgramDescriptorFileMutation();

   
  const resourcesCMSData = useOutletContext();

  const fetchClientAccResDtlsLabel = (key) => {
    if (resourcesCMSData && resourcesCMSData?.pageContent["ClientAccountResourcesDetails"]) {
      const resourcesCMSDataLabel = resourcesCMSData.pageContent["ClientAccountResourcesDetails"];
      return returnLabel(resourcesCMSDataLabel?.Labels, key)
    }
  }

  const fetchMngResoRepoDtlsLabel = (key) => {
    if (resourcesCMSData && resourcesCMSData?.pageContent["ManageResourceRepoDetails"]) {
      const resourcesCMSDataLabel = resourcesCMSData.pageContent["ManageResourceRepoDetails"];
      return returnLabel(resourcesCMSDataLabel?.Labels, key)
    }
  }

  const fetchCommonCMSLabel = (key) => {
    if (resourcesCMSData && resourcesCMSData?.pageContent["CommonComponent"]) {
        const commonCMSDataLabel = resourcesCMSData.pageContent["CommonComponent"];
        return returnLabel(commonCMSDataLabel?.Labels, key)
    }
    return '';
  }

  const returnLabel = (labelArray, key) => {
    if (labelArray.length > 0 && key) {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
    return '';
  }

  /**All () PD title validation  */
  let arrayOfAllPDTitles = []
  !!addedPDData && addedPDData.forEach((eachItem) => {
    arrayOfAllPDTitles.push(eachItem?.ClientAccountProgramDescripitorTitle || eachItem?.clientAccPDTitle)
  })
  const [customPDTitleFieldErrorMsg, setCustomPDTitleFieldErrorMsg] = useState("")
  useEffect(() => {
    if (!!arrayOfAllPDTitles.includes(inputPDTitle?.trim())) {
      const msg = fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ErrorMsgResourceTitleExist') //"This resource title exists for selected client account."
      setCustomPDTitleFieldErrorMsg(msg)
    }
    else {
      setCustomPDTitleFieldErrorMsg("")
    }
  }, [arrayOfAllPDTitles, inputPDTitle])

  /** !!!!!!!! handling submit function  !!!!!!!! */
  const [bodyDataForCreate, setBodyDataForCreate] = useState({});

  const onSubmitForCustomPD = (data) => {
    // console.log("HI...................")
    if (!!data.customPDFile[0]) {
      const file = data.customPDFile[0];

      const bodyData = {
        ProgramDescripitorTitle: data?.customPDTitle || "",
        IsActive: true,
        CreatedBy: emailAddress || "",
        ProgramDescripitorURL: "",
        ProgramDescripitorFileGuid: "",
        ProgramDescripitorFileName: file.name || "",
        ProgramDescripitorFileSize: file.size || "",
        ProgramDescripitorType: "Customized",
      };
      setBodyDataForCreate(bodyData);

      uploadPDFile({ file });
    }
  };

  useEffect(() => {
    if (!!dataOnPDFileUpload?.data?.IsSuccess) {
      const storedFileURL = dataOnPDFileUpload.data.ProgramDescripitorURL;
      const fileGuid = dataOnPDFileUpload.data.Id;
      /**merging file URL to body */
      const bodyData = {
        ...bodyDataForCreate,
        ProgramDescripitorURL: storedFileURL,
        ProgramDescripitorFileGuid: fileGuid
      };
      createProgramDescriptor({ body: bodyData });
    }
  }, [dataOnPDFileUpload?.data?.IsSuccess]);

  /**set values to parent component */
  useEffect(() => {
    if (!!isSuccessOnCreate && !!dataOnCreate?.data) {
      const pdId = dataOnCreate?.data

      setAddedPDData([...addedPDData, {
        Id: pdId || "",
        ProgramDescripitorTitle: bodyDataForCreate?.ProgramDescripitorTitle || "",
        /**clientAccPDTitle must same as ProgramDescripitorTitle for custom PD*/
        clientAccPDTitle: bodyDataForCreate?.ProgramDescripitorTitle || "",
        ProgramDescripitorFileName: bodyDataForCreate?.ProgramDescripitorFileName || "",
        ProgramDescripitorType: "Customized",
        IsActive: true,
        /**TobeDeleted is added only for  Customized PD and not for Standard PD*/
        TobeDeleted: false
      }])
      handleClose()
    }
  }, [isSuccessOnCreate, dataOnCreate?.data]);

  /**tracking user Activity */
  const { trackActivity } = useTrackUserActivity()
  useEffect(() => {
    if (!!isSuccessOnPDFileUpload) {
      trackActivity({
        activitySuccess: !!isSuccessOnPDFileUpload,
        actionType: "Uploaded",
        itemId: dataOnPDFileUpload.data.Id || "",
      })
    }
  }, [isSuccessOnPDFileUpload])
  
  /**handling error states and msgs */
  const [errorTitle, setErrorTitle] = useState("")
  const [errorContent, setErrorContent] = useState("")
  useEffect(() => {
    if (!!isErrorOnPDFileUpload && errorOnPDFileUpload?.response
      ?.data?.ErrorCode === "104") {
      //setErrorTitle("Opps, file scanning failed...!") //ManageResourceRepoDetails.ErrorMsgFileScanFailed
      //setErrorContent("You are not authorized to perform this action.")
      setErrorTitle (fetchMngResoRepoDtlsLabel('ManageResourceRepoDetails.ErrorMsgFileScanFailed'))
      setErrorContent (fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ErrorMsgUnauthorized'))
    }
    else if (!!isErrorOnCreate && errorOnCreate?.response?.data === "ProgrammeDescriptorTitleExists") {
      // setErrorTitle('Resource title exists. Try again...!')
      // setErrorContent(`Resource title "${watch('customPDTitle')}" already exists in our records. Please, try again with different title.`)
      setErrorTitle (fetchMngResoRepoDtlsLabel('ManageResourceRepoDetails.ErrorMsgDuplicateResourceTitle'))
      setErrorContent(`${fetchClientAccResDtlsLabel("ClientAccountResourcesDetails.ResourceTitle")} ${watch('pdTitle')} ${fetchMngResoRepoDtlsLabel('ManageResourceRepoDetails.ErrorMsgResourceExist')} `)
    }
    else {
      setErrorTitle('')
      setErrorContent("")
    }
  }, [isErrorOnCreate, errorOnCreate, isErrorOnPDFileUpload, errorOnPDFileUpload])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >

      <DialogTitle>
        {/* Create Custom Resource */}
        {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.CreateCustomResource')}
      </DialogTitle>
      <DialogContent>
        <MpgItem>
          <MpgInput
            rhfFormInstance={rhfFormInstanceForCustomPD}
            name={"customPDTitle"}
            label= {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.CustomResourceTitle')} //{"Custom Resource Title"}
            fullWidth
          />
          {
            <FormHelperText error={!!customPDTitleFieldErrorMsg}>
              {customPDTitleFieldErrorMsg}
            </FormHelperText>
          }

          <MpgFileUpload
            name="customPDFile"
            label= {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.UploadFile')} //"Upload file"
            rhfFormInstance={rhfFormInstanceForCustomPD}
            persistantMsg= {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.FileType')} //{`Only doc/excel/pdf/ppt file type is allowed`}
          />
        </MpgItem>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleClose()
          }}
        >
          {/*Cancel */}
          {fetchCommonCMSLabel('Common.Cancel')} 
        </Button>

        <Button
          onClick={(e) => {
            /**  e.stopPropagation(); required to use form within form seperately to avoid conflicts between nested form submits. */
            e.stopPropagation();
            rhfFormInstanceForCustomPD.handleSubmit(onSubmitForCustomPD)(e)
          }}
          // type="submit"
          disabled={!!customPDTitleFieldErrorMsg}
        >
          {/* Save */}
          {fetchCommonCMSLabel('Common.Save')} 
        </Button>
      </DialogActions>

      {/** error dialog on file upload action */}
      <MpgErrorDialog
        open={!!isErrorOnCreate || !!isErrorOnPDFileUpload}
        title={errorTitle}
        content={errorContent}
        extraLogicHandlerOnOK={() => {
          if (!!isErrorOnCreate) {
            /**reset mutation */
            resetOnCreate()
          }
          reset({ customPDTitle: "" })
          handleClose()
        }}
      />
      <MpgLoadingDialog
        open={
          !!isLoadingOnCreate ||
          !!isLoadingOnPDFileUpload
        }
      />
    </Dialog>
  )


};

export default UploadAndCreateCustomPD;
